module.exports = __webpack_public_path__ + "img/usa-damage-claims-220.e69ff316.png";